import {
  ClocksService,
  ControlBlocksService,
  NavigationService,
  SetEspTimeSyncSourceModel,
  SetNtpServer_SetNtpServerRequest,
  StateModel,
  TimeSynchronizationSource,
} from "../api";

export const SynchronizationApi = {

  // Получение синхронизации
  getSynchronization: async (id: string) => {
    return ClocksService.getApiClocksSynchronization(id);
  },

  // Получение GPS данных
  getGpsData: async (id: string) => {
    return NavigationService.getApiNavigationSaved(id);
  },

  // Получение NTP данных
  getNtpData: async (id: string) => {
    return ClocksService.getApiClocksSynchronizationNtp(id);
  },

  // Обновление NTP данных
  updateNtpData: async (id: string, payload: SetNtpServer_SetNtpServerRequest): Promise<boolean> => {
    await ClocksService.postApiClocksSynchronizationNtp(id, payload);
    return true;
  },

  // Обновление стейта GPS
  updateGpsState: async (id: string, enabled: boolean): Promise<boolean> => {
    const payload: StateModel = {enabled};
    await ClocksService.postApiClocksSynchronizationGpsState(id, payload);
    return true;
  },

  // Обновление стейта NTP
  updateGpsNtpState: async (id: string, enabled: boolean): Promise<boolean> => {
    const payload: StateModel = {enabled};
    await ClocksService.postApiClocksSynchronizationNtpState(id, payload);
    return true;
  },

  // Синхронизация времени
  synchronizeTime: async (id: string, synchronizationSource: TimeSynchronizationSource): Promise<boolean> => {
    const payload: SetEspTimeSyncSourceModel = {synchronizationSource};
    await ControlBlocksService.postApiControlBlocksTimeSynchronize(id, payload);
    return true;
  },
}
